import { connect } from 'react-redux';
import { selectors as coreSelectors } from 'app-webtech-core';
import * as selectors from '../selectors';
import * as actions from '../actions';
import { TriviaComponent } from '../components/Trivia';

const mapStateToProps = (state) => {
  const player = coreSelectors.player.properties(state);
  return {
    playerIsFullscreen: player.isFullscreen,
    isVisible: selectors.isVisible(state),
    isLeaderboardVisible: selectors.isLeaderboardVisible(state),
    isAnswered: selectors.isAnswered(state),
    revealAnswer: selectors.revealAnswer(state),
  };
};

const mapDispatchToProps = {
  onClose: actions.clear,
};

export const Trivia = connect(mapStateToProps, mapDispatchToProps)(TriviaComponent);
